import React from "react";
import { View, Text, Pressable, ViewStyle, StyleProp } from "react-native";
import Colors from "../../Styles/Shared/Colors";
import { CommonStyleSheet } from "../../Styles/Shared/CommonStyles";
import { TemplateVersion_pages } from "../../Models/PowerSyncModels/models";
import { SubmissionStatuses } from "../../Constants/SubmissionStatuses";
import DynamicSubmitButton from "../DynamicControls/DynamicSubmitButton";

type PageControlFooterProps = {
  currentPage: number;
  maxPages: number;
  backOnPress: () => void;
  nextOnPress: () => void;
  page?: TemplateVersion_pages;
  submissionStatus?: string;
  disabled?: boolean;
  submitForm?: () => void;
  validateAllPages?: () => boolean;
  scrollToBottom?: () => void;
};

const PageControlFooter = (
  props: PageControlFooterProps
): React.ReactElement => {
  const onSubmit = () => {
    if (props.validateAllPages && props.submitForm) {
      if (props.validateAllPages())
        props.submitForm();
      else if (props.scrollToBottom)
        props.scrollToBottom();
    }
  };

  const backButton = (
    <Pressable
      style={({ pressed }) => [
        {
          opacity: pressed ? 0.2 : 1,
        },
        CommonStyleSheet.whiteButton,
        { alignSelf: "flex-start" },
      ]}
      android_ripple={{ color: Colors.whiteTransparent }}
      onPress={() => {
        props.backOnPress();
      }}
    >
      <Text style={CommonStyleSheet.whiteButtonText}>Back</Text>
    </Pressable>
  );
  
  const nextButton = (
    <Pressable
      style={({ pressed }) => [
        {
          opacity: pressed ? 0.2 : 1,
        },
        CommonStyleSheet.greenButton,
        { alignSelf: "flex-end" },
      ]}
      android_ripple={{ color: Colors.whiteTransparent }}
      onPress={() => {
        props.nextOnPress();
      }}
    >
      <Text style={CommonStyleSheet.greenButtonText}>Next</Text>
    </Pressable>
  );

  let style: StyleProp<ViewStyle> = {
    width: "100%",
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 5,
    paddingTop: 0,
    display: "flex",
    flexDirection: "row",
    backgroundColor: Colors.white,
    justifyContent: "space-between",
  };

  if (props.currentPage == 0) style.justifyContent = "flex-end";

  const renderSubmitButton = (
  ): React.ReactElement => {
    let submitButton = props.page?.controls.find(x => x.controlTypeId == 11);

    if (submitButton &&
      props.submissionStatus &&
      props.submissionStatus.toUpperCase() ===
      SubmissionStatuses.DRAFT.toUpperCase()
    )
      return (
        <DynamicSubmitButton
          controlId={submitButton.controlId!}
          controlTypeId={submitButton.controlTypeId}
          label={submitButton.label}
          onSubmit={onSubmit}
          disabled={props.disabled ?? true}
        />
      );
    else return <></>;
  };

  return (
    <View style={style}>
      {props.currentPage != 0 && backButton}
      {props.currentPage != props.maxPages - 1 && nextButton}
      {props.currentPage == props.maxPages - 1 ? renderSubmitButton() : null}
    </View>
  );
};

export default PageControlFooter;
